import api from "./api";

// Endpoints usados pelo campo de "Vínculo de Formulário" (form-link).

// Todos os formulários da empresa (id, name, type). Payload cru.
const listForms = (domain) =>
  api.get("formsByEnterprise", { params: { domain } }).then((resp) => resp.data);

// Layout (array de campos) de um formulário — para listar os componentes.
// Retorna { options (json string), layout, ... }; devolvemos o array já parseado.
const getFormLayout = (formId) =>
  api
    .get("layout/type", { params: { form_id: formId } })
    .then((resp) => {
      try {
        return JSON.parse(resp.data.options);
      } catch (e) {
        return [];
      }
    });

// Preenchimentos (DataForms) de um formulário — para o seletor (id + identifier).
const listDataForms = (formId) =>
  api
    .get("data-form/search", { params: { form_id: formId } })
    .then((resp) => resp.data);

// Valores de um DataForm específico (array por índice, alinhado ao layout).
const getDataFormValues = (dataFormId) =>
  api.get(`data/${dataFormId}`).then((resp) => resp.data);

export default {
  listForms,
  getFormLayout,
  listDataForms,
  getDataFormValues,
};
